<div class="upload__wrapper" id="drop_zone">
  <div class="upload__text-container" data-testid="wcg-upload-file__container">
    <span class="upload__cta">
      <input
        #fileInput
        type="file"
        name="cda_attachment"
        (change)="fileChanged($event)"
        class="upload__file-input"
        [multiple]="multiSelect()"
        data-testid="wcg-upload-file__input"
      />
      <wcg-link
        (handleAction)="fileInput.click()"
        class="upload__action-btn"
        id="file-input"
        >Select files</wcg-link
      >&nbsp;or drop files to upload
    </span>
  </div>
</div>
